import { render, staticRenderFns } from "./comp-color.vue?vue&type=template&id=33149bbc&scoped=true"
import script from "./comp-color.vue?vue&type=script&lang=js"
export * from "./comp-color.vue?vue&type=script&lang=js"
import style0 from "./comp-color.vue?vue&type=style&index=0&id=33149bbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33149bbc",
  null
  
)

export default component.exports